export default "__VITE_ASSET__BF66tSwj__"